import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polyline, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import * as GpxParser from 'gpxparser';
import './Map.css';

// Correction des icônes Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Map = ({ travels, roadtripStatus, miniMap = false }) => {
    const [tracks, setTracks] = useState([]);
    const [bounds, setBounds] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGpxFiles = async () => {
            try {
                const allTracks = [];
                const allPoints = [];
                // Détermine la table et le dossier à utiliser selon le statut
                const isUpcoming = roadtripStatus === "2";
                const travelsToUse = isUpcoming ? travels : travels;
                const gpxFolder = isUpcoming ? "later" : "";
                const idField = isUpcoming ? 'next_roadtrip_travel_id' : 'travel_id';
                const nameField = isUpcoming ? 'next_roadtrip_travel_name' : 'travel_name';
                
                // Charge chaque fichier GPX
                for (const travel of travelsToUse) {
                    const gpxUrl = `https://rt.anthonybois.fr/backend/gpx/${gpxFolder}/${travel[idField]}.gpx`;
                    
                    try {
                        const response = await fetch(gpxUrl);
                        if (!response.ok) throw new Error(`GPX ${gpxUrl} non trouvé`);
                        
                        const gpxText = await response.text();
                        const gpx = new GpxParser();
                        gpx.parse(gpxText);
                        
                        if (gpx.tracks.length > 0) {
                            const points = gpx.tracks[0].points.map(p => [
                                parseFloat(p.lat.toFixed(5)), 
                                parseFloat(p.lon.toFixed(5))
                            ]);
                            
                            allTracks.push({
                                id: travel[idField],
                                name: travel[nameField],
                                date: travel.travel_date,
                                points,
                                color: '#' + Math.floor(Math.random()*16777215).toString(16)
                            });
                            
                            allPoints.push(...points);
                        }
                    } catch (err) {
                        console.warn(`Erreur lors du chargement du GPX ${gpxUrl}:`, err);
                    }
                }

                if (allPoints.length > 0) {
                    const bounds = L.latLngBounds(allPoints);
                    setBounds(bounds);
                    setTracks(allTracks);
                } else {
                    setError('Aucun tracé GPX trouvé');
                }
            } catch (err) {
                console.error('Erreur lors du chargement des GPX:', err);
                setError('Erreur lors du chargement des tracés');
            } finally {
                setLoading(false);
            }
        };

        if (travels && travels.length > 0) {
            fetchGpxFiles();
        }
    }, [travels, roadtripStatus]);

    if (loading) return <div className="spinner-border text-primary" role="status" />;
    if (error) return <div className="alert alert-danger">{error}</div>;
    if (tracks.length === 0) return null;

    return (
        <div style={{ height: miniMap ? '100%' : '666px', width: '100%' }}>
            <MapContainer
                bounds={bounds}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={!miniMap}
                zoomControl={!miniMap}
                dragging={!miniMap}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                
                {tracks.map(track => (
                    <Polyline
                        key={track.id}
                        positions={track.points}
                        color={track.color}
                        weight={miniMap ? 4 : 6}
                    >
                        {!miniMap && (
                            <Popup>
                                <div>
                                    <strong>{track.name}</strong>
                                    {track.date && (
                                        <div>Date: {new Date(track.date).toLocaleDateString()}</div>
                                    )}
                                </div>
                            </Popup>
                        )}
                    </Polyline>
                ))}
            </MapContainer>
        </div>
    );
};

export default Map; 